import React, { FC, ReactNode } from "react";
import classNames from "classnames";

import { Icon } from "../../common";

type Props = {
  icon: string;
  title: string;
  description: ReactNode;
  dataTest?: string;
  iconPosition?: "top" | "middle" | "bottom";
};

const iconPositionClassMap = {
  top: "items-start",
  middle: "items-center",
  bottom: "items-end",
};

export const InformationItem: FC<Props> = ({
  icon,
  title,
  description,
  dataTest,
  iconPosition = "middle",
}) => {
  const className = iconPositionClassMap[iconPosition];

  return (
    <div className={classNames("flex gap-4", className)} data-test={dataTest}>
      <div className="flex-none flex h-16 w-16 rounded-full bg-extra-10 justify-center items-center">
        <Icon icon={icon} size={32} className="text-gray-500" />
      </div>

      <div className="flex flex-col text-base">
        <h6 className="font-poppins font-bold" data-test={`${dataTest}-title`}>
          {title}
        </h6>

        <span
          className="font-medium text-gray-300"
          data-test={`${dataTest}-description`}
        >
          {description}
        </span>
      </div>
    </div>
  );
};
